/** @jsxImportSource theme-ui */
import { ThemeUIProvider } from "theme-ui";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import theme from "./styles/theme";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import NotFound404 from "./pages/NotFound404";
import RequireAuth from "./auth/RequireAuth";
import ProtectedRoute from "./auth/ProtectedRoute";
import Users from "./pages/Users";

const App = () => {
  return (
    <ThemeUIProvider theme={theme}>
      <RequireAuth>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/users"
              element={
                <ProtectedRoute requiredRole="Admin">
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="Admin">
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </Router>
      </RequireAuth>

    </ThemeUIProvider>
  );
};

export default App;
